import { gql } from "@apollo/client";

export const ACTIVITY_FIELDS_QUERY = gql`
  query activityFields {
    activityFields {
      id
      code
      name
    }
  }
`;

export const DOCUMENT_STATES = gql`
  query documentStates($documentTypeId: Int!) {
    documentStates(documentTypeId: $documentTypeId) {
      stateId
      name
    }
  }
`;
